import React, { useEffect, useState } from "react";
import StorefrontTitle from "../shared/storefront-title.component";
import Translations from "../../services/translation.service";
import OtpInput from "../shared/otp-screen/otpInputField";
import Storage from "../../services/storage.service";
import Advertisement from "../../services/advertisement.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import AdvertismentOptList from "./advertisment-option-list";


let subscriptions = [];
export default function AdvertismentOtp(props) {
  const [optValue, setOptValue] = useState("");
  const [isError, setError] = useState(false);
  const [number, setNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    subscriptions.push(
      Storage.get_obsrv("act_number").subscribe(data => {
        if (data?.number) {
          setNumber(data.number)
        } else {
          props.history.push("/advertisement");
        }
      })
    );
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  let prefix = "stm_otp_";
  const prefix_general = "stm_advertisement_otp_"

  const handleOtpForm = (value) => {
    setOptValue(value)
  }

  const handleOtpError = (value) => {
    setError(value)
  }

  const handleSendAgain = () => {
    setOptValue("")
    setLoading(true)
    let data = {
      number: number,
      fraud_type: "RestrictCall"
    }
    Advertisement.getOTP(data)
      .then(response => {
        if (response && response?.data) {
          setLoading(false);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleSubmit = () => {

    setLoading(true)
    let payload = {
      number: number,
      otp: optValue
    }
    Storage.set("advertisementOtpError", true, true);
    Advertisement.verifyOTP(payload)
      .then(response => {
        if (response && response?.data) {
          Storage.clear("advertisementOtpError");
          Storage.set("act_step_detail", {
            step1: {
              status: "isDone",
            },
            step2: {
              status: "isDone",
            },
            step3: {
              status: "inProgress",
            }
          })
          setShowList(true);
          // setLoading(false);
        } else {
          setLoading(false);
          setError(true)
        }

      })
      .catch(error => {
        setLoading(false);
        setError(true)
        Storage.clear("advertisementOtpError");
      });

  }

  return (<>
    {!showList ?
      loading ? <SpinnerTimeLoader /> :
        <div className="otp-screen-wrapper">
          <StorefrontTitle
            title={Translations.keys[prefix_general + "title"] ||
              "Verification code required"}
            desc={Translations.keys[prefix_general + "desc"] ||
              "Please enter the 6 digits code you have received in an SMS to verify."}
          />
          <OtpInput
            otpError={isError}
            handleOtpForm={handleOtpForm}
            handleOtpError={handleOtpError} />

          {isError && <p className="error">{Translations.keys[prefix + "error"]}</p>}

          <div className="send-message">
            <p>{Translations.keys[prefix + "received"]}</p>
            <span onClick={handleSendAgain}>
              {Translations.keys[prefix + "send_again"]}
            </span>
          </div>
          <button className={!optValue ? "disable" : ""}
            onClick={handleSubmit} disabled={!optValue}>
            {Translations.keys[prefix + "continue"]}
          </button>
        </div>
      : <AdvertismentOptList
        history={props.history}
        number={number}
        otp={optValue} />}
  </>)
}